import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Checkbox, Col, Divider, Radio, Row } from 'antd'
import { getDifference } from '../../store/action/event.action'
import {
  EditOutlined,
  HistoryOutlined,
  MinusOutlined,
  PlusOutlined,
} from '@ant-design/icons'

const EventDiffItem = (props) => {
  const {
    parent,
    child,
    isAdded,
    isDeleted,
    isSame,
    isIgnored,
    name,
    isUpdated,
  } = props.event
  // console.log(isAdded, isDeleted, isSame, isUpdated);
  const backgroundColor = isDeleted
    ? 'tomato'
    : isAdded
      ? 'lightgreen'
      : isSame
        ? 'lightblue'
        : '#FFC400'

  const lightBackground = isDeleted
    ? '#ff8974'
    : isAdded
      ? '#b0f7b0'
      : isSame
        ? '#caedf9'
        : '#FFE57F'

  console.log(isIgnored, props.hidden)

  // return (
  //     <>
  // <Row style={{backgroundColor: lightBackground, paddingLeft: 8}} hidden={(props.hidden)}>
  //     <Col hidden={isSame} flex={"24px"}>
  //         <Checkbox onChange={(e) => props.onSelect(e.target.checked)}/>
  //     </Col>
  //     <Col hidden={!parent} flex={"auto"}>
  //         <h4 style={{margin: 0}}>
  //             Date : &nbsp;
  //             <i>S {(parent?.date >= 0) ? "+ " + parent?.date :
  //                 "- " + Math.abs(parent?.date)
  //             }</i>
  //         </h4>
  //     </Col>
  //     <Col hidden={!child} flex={"50%"}>
  //         <h4 style={{margin: 0}}>
  //             Date : &nbsp;
  //             <i>S {(child?.date >= 0) ? "+ " + child?.date :
  //                 "- " + Math.abs(child?.date)
  //             }</i>
  //         </h4>
  //     </Col>
  // </Row>
  // <Row hidden={props.hidden} style={{backgroundColor}} className="diff-row" wrap={false}>
  //     <Col className="diff-parent" flex="50%">
  //         <Row wrap={false} gutter={10}>
  //             <Col hidden={isSame}> {
  //                 isDeleted ? <MinusOutlined style={{color: 'darkblue'}} /> :
  //                 isAdded ? <PlusOutlined style={{color: 'darkblue'}}/> :
  //                 (isUpdated && !isSame )? <EditOutlined style={{color: 'darkblue'}}/> :
  //                 isIgnored ? <HistoryOutlined style={{color: 'darkblue'}}/> : null
  //                 }
  //             </Col>
  //             <Col flex="auto">
  //                 <h3 style={{margin: 0}}>{parent?.title}</h3>
  //                 <p hidden={!parent?.message}>{parent?.message}</p>
  //             </Col>
  //         </Row>
  //     </Col>
  //     <Col className="diff-child" flex="50%">
  //         <h3 style={{margin: 0}}>{child?.title}</h3>
  //         <p hidden={!child?.message}>{child?.message}</p>
  //     </Col>
  // </Row>
  //     </>
  // )

  return (
    <Row>
      <Col flex='auto' className='modal-padding'>
        <Row>
          <h2 style={{ margin: 0 }}>
            Surgery: <i>{name}</i>
          </h2>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <i>*S = Patient’s Surgery Date*</i>
        </Row>
        <h4 hidden={!parent} style={{ marginBottom: 0 }}>
          {isAdded ? 'New Reminder Added' : 'New Reminder'}
        </h4>
        <Row
          hidden={!parent}
          style={{
            backgroundColor: lightBackground,
            paddingLeft: 8,
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5,
          }}
          hidden={props.hidden}
        >
          <Col hidden={!parent} flex={'auto'}>
            <h4 style={{ margin: 0 }}>
              Date : &nbsp;
              <i>
                S{' '}
                {parent?.date >= 0
                  ? '+ ' + parent?.date
                  : '- ' + Math.abs(parent?.date)}
              </i>
            </h4>
          </Col>
        </Row>
        <Row
          hidden={!parent}
          style={{ backgroundColor }}
          className='diff-row'
          wrap={false}
        >
          <Col className='diff-parent' flex='auto'>
            <Row wrap={false} gutter={10}>
              <Col flex='auto'>
                <h3 style={{ margin: 0 }}>{parent?.title}</h3>
                <p hidden={!parent?.message}>{parent?.message}</p>
              </Col>
            </Row>
          </Col>
        </Row>
        <br hidden={!parent} />
        <h4 hidden={!child} style={{ marginBottom: 0 }}>
          {isDeleted ? 'Current Reminder Deleted' : 'Current Reminder'}
        </h4>
        <Row
          hidden={!child}
          style={{
            backgroundColor: lightBackground,
            paddingLeft: 8,
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5,
          }}
          hidden={props.hidden}
        >
          <Col hidden={!child} flex={'auto'}>
            <h4 style={{ margin: 0 }}>
              Date : &nbsp;
              <i>
                S{' '}
                {child?.date >= 0
                  ? '+ ' + child?.date
                  : '- ' + Math.abs(child?.date)}
              </i>
            </h4>
          </Col>
        </Row>
        <Row
          hidden={!child}
          style={{ backgroundColor }}
          className='diff-row'
          wrap={false}
        >
          <Col className='diff-child' flex='auto'>
            <h3 style={{ margin: 0 }}>{child?.title}</h3>
            <p hidden={!child?.message}>{child?.message}</p>
          </Col>
        </Row>
        <br />
      </Col>
      <Col span={24}>
        <Radio.Group
          value={props.selectedvalue}
          onChange={(e) => props.onSelect(e.target.value)}
          className='radio-event-diff'
        >
          <Radio value={1}>Accept change.</Radio>
          {/* <Radio value={0}>Yes, I accept the changes</Radio> */}
          <Radio value={0}>Discard change.</Radio>
          {/* <Radio value={1}>No, I want to discard the changes</Radio> */}
          <Radio value={-1}>Skip change.</Radio>
          {/* <Radio value={-1}>Skip the changes for now.</Radio> */}
        </Radio.Group>
      </Col>
    </Row>
  )
}

EventDiffItem.propTypes = {
  isLoading: PropTypes.bool,
  event: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.event.isLoading,
    customer: state.profile.customer,
    company: state.profile.company,
    surgerytype: state.event.surgerytype,
    events: state.event.events,
    differences: state.event.differences,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getDiffs: (params) => dispatch(getDifference(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventDiffItem)
